<template>  
  <div v-if="geoRegions">
    <div class="tree">  
    <q-checkbox v-model="showAll" :label="$t('global.ShowAll')" color="light" @input="showAllChanged(showAll)" />  
    &nbsp;
    <q-toggle
        label="Akt."
        v-model="isActive"
        
   />
      <q-tree 
        :nodes="geoRegionsShow" 
        :expanded.sync="propsExpanded"
        node-key="IdGeoRegion"
        :selected.sync="selected"
        :ticked.sync="ticked"
        :tick-strategy="tickStrategy" 
      >
        <div slot="default-header" slot-scope="prop">
          <div v-if="prop.node.IdGeoRegion">
            {{ prop.node.label }}
          </div>
        </div>
      </q-tree>
      <q-card-separator/>
      <q-item clickable v-ripple v-if="overlays.length != 0">
        <div>        
          <div v-for="overlay in overlays" :key="overlay.id">
            <q-checkbox v-model="overlay.show" :label="overlay.name" color="light" @input="showOverlayChanged(overlay)" />
          </div>
        </div>
      </q-item>
    </div>
  </div>
</template>

<script>
import { openURL } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SelectGeoRegionTree',
  data () {
    return {
      form: {
        SessionId: null,
        action: 'GeoRegionsTree',
        IdLanguage: 1
      },
      selected: null,
      ticked: [],
      tempSelect: [],
      tickStrategy: 'strict',
      propsExpanded: [],
      geoRegions: null,
      geoRegionsFlat: [],
      geoObjects:[],
      showAll: false,
      showOverlay: [],
      overlays: [],
      isActive: true,
    }
  },
  methods: {
    showAllChanged(){
        if(this.showAll){
           this.geoRegionsFlat.forEach(element => {
           this.ticked.push(element.IdGeoRegion)
           eventBus.$emit('showObject', element.LeafletObject)          
          })
        }
        else{          
          this.removeAllObjects()
        }
    },
    showOverlayChanged(value){
      if(value.show){
        value.layer = L.tileLayer(value.path + '/{z}/{x}/{y}.png', {tms: true, opacity: 0.7, attribution: "", minZoom: 16, maxZoom: 21})
      }
      eventBus.$emit('changedOverlay', value) 
    },
    removeAllObjects(){
      this.geoRegionsFlat.forEach(element => {
        eventBus.$emit('removeObject', element.LeafletObject)          
      })
      this.ticked = []
      this.geoObjects.forEach(element => {
        eventBus.$emit('removeObject', element)          
      })
    },
    makeTreeFlat(elements){ 
      elements.forEach(element => {
        console.log('GeoRegion: ' + element.label)
        //Deconstruct poly
        var pl = element.poly.substr(10, element.poly.length - 12)
        var gpl = pl.split(',')
        var cords = [];
        gpl.forEach(gp => {
          //console.log('     gp: ' + gp)
          var gpls = gp.trim().split(' ')
          var LatLong = {Lat: gpls[1], Long: gpls[0]}
          console.log( gpls[1] + ', ' + gpls[0]   )
          var cord = [
            gpls[1],
            gpls[0]
          ]
          cords.push(cord)                 
        })
        //Make Polygon and save to geoRegionsFlat
        var label = element.label + '<br>' + + round(element.squareMeter / 10000, 4) + ' ha'
        var poligon = L.polygon(cords).bindTooltip(label,{permanent: true, direction:"top", opacity: 0.6  }).setStyle({weight: 2})
                  poligon.name = element.label
                  poligon.IdGeoRegion = element.IdGeoRegion
        
        this.geoRegionsFlat[element.IdGeoRegion] = { IdGeoRegion: element.IdGeoRegion, LeafletObject: poligon, Label: element.label, GeoRegion: element }
        //recursive call:
        this.makeTreeFlat(element.children)
      })
    },
    editPolygon(IdGeoRegion){
      eventBus.$emit('editObject', this.geoRegionsFlat[IdGeoRegion])
    },
    showPolygonTreeOnMap(IdGeoRegion){
      eventBus.$emit('showObject', this.geoRegionsFlat[IdGeoRegion].LeafletObject)
    },
    addNewGeoRegionToNode(IdGeoRegion){
      eventBus.$emit('addGeoRegionDialog', { IdParent: IdGeoRegion, Label: this.geoRegionsFlat[IdGeoRegion].Label })
    },
    deleteGeoRegion(IdGeoRegion){
      this.$q.dialog({
        title: this.geoRegionsFlat[IdGeoRegion].Label + ' Löschen',
        message: '',
        ok: 'Ja',
        cancel: 'Nein'
      }).then(() => {
          this.form.SessionId = this.$store.state.session.SessionId
          this.form.action = "DeleteGeoRegion"
          this.form.IdGeoRegion = IdGeoRegion
          axios.post(this.$apiUrl,
          qs.stringify(this.form),
          {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(response => {
              this.submitting = false
              console.log(response.data)
              console.log(response)
              if(response.status == 200){ 
                if(response.data == "OK"){
                  this.$q.notify({ message: 'Gelöscht', type: 'positive' })
                  //eventBus.$emit('removeObject', this.geoRegionsFlat[IdGeoRegion].LeafletObject) 
                  eventBus.$emit('loadDialog', 'SideDialogWelcome') // to remove the current dialog
                  eventBus.$emit('closeDialog', null)
                  eventBus.$emit('removeAllObjects', null) 
                  delete this.geoRegionsFlat[IdGeoRegion]
                  this.loadGeoRegionsTree(true)
                }
              }
              else{
                  this.$store.dispatch('setSession', null)
                  this.$q.notify('Something Wrong.')
              }
          })
          .catch(e => {
              this.submitting = false
              if(e.response.status == 403){
                  //this.errors.push(this.translate('LoginError'))
                  this.$q.notify('Something Wrong.')

              }
              console.log(e);
              this.$store.dispatch('setSession', null)
          })

      }).catch(() => {
        //gets called when no is clicked on dialog
      })
    },
    loadGeoRegionsTree(noShow){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GeoRegionsTree"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
              console.log(response.data)
              this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
              this.geoRegions = response.data      
              //this.makeTreeFlat(response.data)
              this.makeTreeFlat(this.geoRegionsShow)
              this.showAll = false
              if(noShow != true){
                this.showAll = true
                this.showAllChanged()

              }
          }
          else{
              this.$store.dispatch('setSession', null)
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              this.$q.notify('Something Wrong.')
          }
          console.log(e);
          this.$store.dispatch('setSession', null)
      })
    },
    getOverlays(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetOverlays"
      
      axios.post(this.$apiGoUrl + '/overlay/',
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
            response.data.forEach(element => {
              element.show = false         
            })
            this.overlays = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }
  },
  watch: {
    ticked: function (newValue, oldValue) {  
      if(newValue.length != oldValue.length){
        if(newValue.length > oldValue.length){
          this.tempSelect = newValue.filter(x => !oldValue.includes(x));
          eventBus.$emit('showObjectCenter', this.geoRegionsFlat[this.tempSelect].LeafletObject)
        }  
        else{
          //Did not delete after initial display, commented it out and seams ok, Theo 5.7.2021
          //if(this.tempSelect.length != 0){
            this.tempSelect = oldValue.filter(x => !newValue.includes(x));
            if(this.geoRegionsFlat[this.tempSelect] != undefined){
              eventBus.$emit('removeObject', this.geoRegionsFlat[this.tempSelect].LeafletObject)

            }
          //}
        }
      }
    },
    selected: function(newValue, oldValue){
        if(newValue != null){
          this.propsExpanded.push(newValue)
          eventBus.$emit('editGeoRegion', this.geoRegionsFlat[newValue])
        }
        else{
           this.propsExpanded = this.propsExpanded.filter(e => e !== oldValue)
        }
    },
    isActive: function(newValue, oldValue){
      this.geoRegionsFlat = []
      if(newValue){
        this.makeTreeFlat(this.geoRegionsShow)
      }
      else{
        this.makeTreeFlat(this.geoRegions)
      }
      
    }
  },
  created () {
    eventBus.$on('showObject', (data) => {
      this.geoObjects.push(data)
    }),
    eventBus.$on('removeAllObjects', (data) => {
      this.removeAllObjects()
    }),
    eventBus.$on('deleteGeoRegion', (data) => {
      this.deleteGeoRegion(data)
    }),
    eventBus.$on('loadGeoRegion', (data) => {
      this.loadGeoRegionsTree(data)
      this.getOverlays()
    }),
    eventBus.$on('savePolygon', (IdGeoRegion) => { 
        var poly = this.geoRegionsFlat[IdGeoRegion].LeafletObject.getLatLngs()
        var poslist
        poly.forEach(cords => {
          poslist = cords
          cords.forEach(cord => {
            
          })
        })
        var updateGeoRegion = { IdGeoRegion: IdGeoRegion, PosList: poslist }
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "updateGeoRegionPolygon"
        this.form.geo_region = updateGeoRegion
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            console.log(response.data)
            console.log(response)
            if(response.status == 200){ 
                if(response.data == "OK"){
                  this.$q.notify({ message: 'Updated', type: 'positive' })
                }

            }
            else{
                this.$store.dispatch('setSession', null)
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
            this.submitting = false
            if(e.response.status == 403){
                this.$q.notify('Something Wrong.')
            }
            console.log(e);
            this.$store.dispatch('setSession', null)
        })
    })
  },
  computed:{
    geoRegionsShow: function (){
      var tempList = []
      this.geoRegions.forEach(node => {
          if(this.isActive){
            if (node.IsActive){
              tempList.push(node)
            }   
          }  
          else{
            tempList.push(node)
          }    
        })
      return tempList
    }
  },
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>

<style scoped>
.tree{
        padding: 10px;
        padding-top: 5px;
    }
</style>
